import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import { PreloaderWrapper } from 'components/containers';
import { DependentRouter } from 'components/routers';
import { useDependentDetail, DependentDetailProvider } from 'components/contexts';
import { BackButton, DataNotFound, Topography, TabMenu } from 'components/ui';

import { dependentDeatils } from 'store/actions/dependents.action';
import { dependentsSelector } from 'store/reducers/dependents.reducer';

import { dependentMenu } from './DependentMenu.mocks';

import styles from './DependentsLayout.module.scss';

export const DependentsLayout = () => {
  return (
    <div className='pl-5'>
      <BackButton back="/dependents" />
      <DependentDetailProvider>
        <Content />
      </DependentDetailProvider>
    </div>
  );
};

const Content = () => {
  const { detailed, isLoading } = useSelector(dependentsSelector);
  const { value, setValue } = useDependentDetail();
  const id:any = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!detailed) dispatch(dependentDeatils(id));
    else if (detailed.id !== id.id) dispatch(dependentDeatils(id));
    else setValue(detailed);
  }, [dispatch, id, detailed, setValue]);

  if (isLoading) return <PreloaderWrapper />;

  if (!value) return <DataNotFound>No dependent found</DataNotFound>;

  return (
    <>
      <Topography.H3 className={styles.name}>{`${value.firstName} ${value.middleName} ${value.lastName}`}</Topography.H3>
      <TabMenu data={dependentMenu} />
      <div className={styles.pages}>
        <DependentRouter />
      </div>
    </>
  );
};
